import "../../../../index76.css";
import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { _ as e } from "../../../../cs-piwRuCFZ.js";
import "../../../../type-BFTbooL7.js";
const i = "_expansion-indicator_jys9u_1", d = "_end-border_jys9u_13", c = "_start-border_jys9u_14", _ = "_indicator_jys9u_20", l = "_start_jys9u_14", u = "_end_jys9u_13", p = "_single_jys9u_40", s = {
  expansionIndicator: i,
  endBorder: d,
  startBorder: c,
  indicator: _,
  start: l,
  end: u,
  single: p
};
function B(t) {
  const {
    isExpanded: o,
    variant: n
  } = t;
  return o ? /* @__PURE__ */ a(
    "div",
    {
      className: e(
        s.expansionIndicator,
        n === "start" && s.start,
        n === "end" && s.end,
        n === "single" && s.single
      ),
      children: [
        /* @__PURE__ */ r("div", { className: s.startBorder }),
        /* @__PURE__ */ r("div", { className: s.indicator }),
        /* @__PURE__ */ r("div", { className: s.endBorder })
      ]
    }
  ) : null;
}
export {
  B as default
};
